<template>
    <v-app id="inspire">
        <div class="payroll-report-show-wrap">
            <v-layout class="inv-top-header mb-4">
              <v-flex>
                <p class="text-uppercase caption mb-0">Payroll/Payroll Report</p>
                <h2 class="headline" v-if="items.length === 1">{{items[0].first_name}}, {{items[0].last_name}}</h2>
              </v-flex>
              <v-spacer></v-spacer>
              <v-btn class="header-btn-back mr-0 mb-3 mt-0" @click="$router.go(-1)">
                <v-icon class="header-btn-back-icon">navigate_before</v-icon>
                Back
              </v-btn>
            </v-layout>

            <v-flex class="header-search-single">
                <v-layout xs12 class="mt-2">
                    <v-flex class="mr-2" d-flex style="max-width: 300px;">
                        <v-menu
                            ref="menu1"
                            :label="`Pay Period`"
                            :close-on-content-click="false"
                            v-model="menu1"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                  v-on="on"
                                  :value="titleDateFormat()"
                                  :label="`Pay Period${payPeriodName && titleDateFormat() ? ' (' + payPeriodName + ')' : ''}`"                                    
                                  persistent-hint
                                  prepend-icon="event"
                                  placeholder="Please Select"
                                  readonly
                              ></v-text-field>
                            </template>
                            <v-date-picker 
                                :value="weekStartEnd"
                                :title-date-format="weekDateFormat"
                                first-day-of-week="1"
                                multiple
                                @input="updateWeek"
                            >
                            </v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex>
                        <v-btn large color="primary" dark class="mr-0" style="min-width: 50px;" @click="getPayrollReport">
                            Apply
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-container class="grid-list-lg px-0">
              <v-layout class="wrap justify-end xs12 px-0">
                <v-flex v-if="activePayrollData.includes('hourly_rate')" class="xs12 sm6 md2 text-right">
                  <div class="px-2 py-1" style="border-right: solid 2px #f15891;">
                    <div class="grey--text">Regular Pay</div>  
                    <div class="title" style="min-height: 20px;">
                      <template v-if="items.length === 1 && !no_data.includes(items[0].hourly_pay_amount)">
                        <span class="body-1 grey--text">$</span>{{items[0].hourly_pay_amount}}
                      </template>
                      <span v-else class="grey--text caption">No Data</span>
                    </div>  
                  </div>
                </v-flex>
                <v-flex v-if="activePayrollData.includes('overtime_hours')" class="xs12 sm6 md2 text-right">
                  <div class="px-2 py-1" style="border-right: solid 2px #60a35c;">
                    <div class="grey--text">Overtime Pay</div>  
                    <div class="title" style="min-height: 20px;">
                      <template v-if="items.length === 1 && !no_data.includes(items[0].overtime_pay_amount)">
                        <span class="body-1 grey--text">$</span>{{items[0].overtime_pay_amount}}
                      </template>
                      <span v-else class="grey--text caption">No Data</span>  
                    </div>  
                  </div>
                </v-flex>
                <v-flex v-if="activePayrollData.includes('mileage_rate')" class="xs12 sm6 md3 text-right">
                  <div class="px-2 py-1" style="border-right: solid 2px #ed9319;">
                    <div class="grey--text">Mileage Reimbursement</div>  
                    <div class="title" style="min-height: 20px;">
                      <template v-if="items.length === 1 && !no_data.includes(items[0].mileage_reimbursement_amount)">
                        <span class="body-1 grey--text">$</span>{{items[0].mileage_reimbursement_amount}}
                      </template>
                      <span v-else class="grey--text caption">No Data</span>
                    </div>  
                  </div>
                </v-flex>
                <v-flex 
                  v-if="items.length === 1 && parseFloat(items[0].revenue_rate) !== 0 && activePayrollData.includes('base_percentage')"
                  class="xs12 sm6 md3 text-right"
                >
                  <div class="px-2 py-1" style="border-right: solid 2px #249caa;">
                    <div class="grey--text">Performance Bonus</div>  
                    <div class="title" style="min-height: 20px;">
                      <template v-if="items.length === 1 && !no_data.includes(items[0].performance_bonuse_total)">
                        <span class="body-1 grey--text">$</span>{{items[0].performance_bonuse_total}}
                      </template>
                      <span v-else class="grey--text caption">No Data</span>
                    </div>  
                  </div>
                </v-flex>
                <v-flex class="xs12 sm6 md2 text-right">
                  <div class="px-2 py-1" style="border-right: solid 2px #ffeb3c;">
                    <div class="grey--text">Total Pay</div>  
                    <div class="title" style="min-height: 20px;">
                      <template v-if="items.length === 1 && !no_data.includes(items[0].complete_total)">
                        <span class="body-1 grey--text">$</span>{{items[0].complete_total}}
                      </template>
                      <span v-else class="grey--text caption">No Data</span>
                    </div>  
                  </div>
                </v-flex>

              </v-layout>
            </v-container>

            <v-container class="grid-list-lg px-0">
              <v-alert class="pa-2" v-if="items.length === 1 && !no_data.includes(items[0].note)" :value="items.length === 1 && !no_data.includes(items[0].note)" outlined color="info" icon="comment" transition="scale-transition" style="background: white;">
                <span>Note: </span> <span style="color: rgba(0, 0, 0, .87);">{{ items[0].note }}</span>
              </v-alert>
              <v-layout class="wrap xs12 px-0 fill-height">
                <v-flex class="sm12" :class="{md6: items.length === 1 && parseFloat(items[0].revenue_rate) !== 0}">
                  <v-card class="fill-height">
                    <h3 class="px-4 py-6">Employee Figures</h3>
                    <v-divider></v-divider>
                    <v-data-table
                      :headers="headers1"
                      :items="items"
                      hide-default-footer
                      hide-default-header
                      class="elevation-0 sr-pl-sh-table"
                      colwidth-1='30px'
                      :loading="loading || payrollReportLoading"
                      loader-height="2"
                      mobile-breakpoint="100">
                      <template v-slot:item="{item}">
                        <tr>
                          <td style="width: 280px;">Hire Date</td>
                          <td>
                            <span v-if="!no_data.includes(item.hire_date)">{{ item.hire_date }}</span>
                            <em v-else class="grey--text">No Data</em>
                          </td>
                        </tr>
                        <tr>
                          <td style="width: 280px;">1st Day Pay Period (Monday)</td>
                          <td>
                            <span v-if="!no_data.includes(item.week_start)">{{ onlyDate(item.week_start) }}</span>
                            <em v-else class="grey--text">No Data</em>
                          </td>
                        </tr>
                        <tr>
                          <td style="width: 280px;">Last Day (Sunday)</td>
                          <td>
                            <span v-if="!no_data.includes(item.week_end)">{{ onlyDate(item.week_end) }}</span>
                            <em v-else class="grey--text">No Data</em>
                          </td>
                        </tr>
                        <tr v-if="activePayrollData.includes('mileage_rate')">
                          <td style="width: 280px;">Mileage Rate</td>
                          <td>
                            <span v-if="!no_data.includes(item.mileage_rate)">${{ item.mileage_rate }} / mi.</span>
                            <em v-else class="grey--text">No Data</em>
                          </td>
                        </tr>
                        <tr v-if="activePayrollData.includes('hourly_rate')">
                          <td style="width: 280px;">Hourly Rate</td>
                          <td>
                            <span v-if="!no_data.includes(item.hourly_rate)">${{ item.hourly_rate }} / hr.</span>
                            <em v-else class="grey--text">No Data</em>
                          </td>
                        </tr>
                        <tr v-if="activePayrollData.includes('yard_rate')">
                          <td style="width: 280px;">Yard Rate</td>
                          <td>
                            <span v-if="!no_data.includes(item.yard_rate)">${{ item.yard_rate }} / yard</span>
                            <em v-else class="grey--text">No Data</em>
                          </td>
                        </tr>
                        <tr v-if="activePayrollData.includes('fixed_rate')">
                          <td style="width: 280px;">Fixed Rate</td>
                          <td>
                            <span v-if="!no_data.includes(item.fixed_rate)">${{ item.fixed_rate }} / pay period</span>
                            <em v-else class="grey--text">No Data</em>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-flex>

                <v-flex v-if="items.length === 1 && parseFloat(items[0].revenue_rate) !== 0 && activePayrollData.includes('base_percentage')" class="sm12 md6">
                  <v-card class="fill-height">
                    <h3 class="px-4 py-6">Performance Bonus</h3>
                    <v-divider></v-divider>
                    <v-data-table
                      :items="items"
                      hide-default-footer
                      hide-default-header
                      :headers="headers2"
                      class="elevation-0 sr-pl-sh-table"
                      colwidth-1='30px'
                      :loading="loading || payrollReportLoading"
                      loader-height="2"
                      mobile-breakpoint="100">
                      <template v-slot:item="{item}">
                        <tr v-if="activePayrollData.includes('residential_revenue')">
                          <td style="width: 280px;">Pay Period Residential Revenue</td>
                          <td>
                            <span v-if="!no_data.includes(item.residential_revenue)">${{ item.residential_revenue }}</span>
                            <em v-else class="grey--text">No Data</em>
                          </td>
                        </tr>
                        <tr v-if="activePayrollData.includes('residential_bonus')">
                          <td style="width: 280px;">Pay Period Additional Residential Services Revenue</td>
                          <td>
                            <span v-if="!no_data.includes(item.residential_bonus)">${{ item.residential_bonus }}</span>
                            <em v-else class="grey--text">No Data</em>
                          </td>
                        </tr>
                        <tr v-if="activePayrollData.includes('commercial_revenue')">
                          <td style="width: 280px;">Pay Period Commercial Revenue</td>
                          <td>
                            <span v-if="!no_data.includes(item.commercial_revenue)">${{ item.commercial_revenue }}</span>
                            <em v-else class="grey--text">No Data</em>
                          </td>
                        </tr>
                        <tr v-if="activePayrollData.includes('commercial_bonus')">
                          <td style="width: 280px;">Pay Period Additional Commercial Services Revenue</td>
                          <td>
                            <span v-if="!no_data.includes(item.commercial_bonus)">${{ item.commercial_bonus }}</span>
                            <em v-else class="grey--text">No Data</em>
                          </td>
                        </tr>
                        <tr v-if="activePayrollData.includes('revenue')">
                          <td style="width: 280px;">Pay Period Revenue</td>
                          <td>
                            <span v-if="!no_data.includes(item.revenue_sum)">${{ item.revenue_sum }}</span>
                            <em v-else class="grey--text">No Data</em>
                          </td>
                        </tr>
                        <tr v-if="activePayrollData.includes('revenue_adjustment')">
                          <td style="width: 280px;">Revenue Adjustment</td>
                          <td>
                            <span v-if="!no_data.includes(item.revenue_adjustment)">${{ item.revenue_adjustment }}</span>
                            <em v-else class="grey--text">No Data</em>
                          </td>
                        </tr>
                        <tr>
                          <td style="width: 280px;">Base Percentage</td>
                          <td>
                            <span v-if="!no_data.includes(item.revenue_rate)">{{ item.revenue_rate }}%</span>
                            <em v-else class="grey--text">No Data</em>
                          </td>
                        </tr>
                        <tr>
                          <td style="width: 280px;">Subtotal</td>
                          <td>
                            <span v-if="!no_data.includes(item.performance_bonuse_subtotal)">
                              ${{ item.performance_bonuse_subtotal }}
                            </span>
                            <em v-else class="grey--text">No Data</em>
                          </td>
                        </tr>
                        <tr v-if="activePayrollData.includes('hourly_rate')">
                          <td style="width: 280px;">Hourly Pay</td>
                          <td>
                            <span v-if="!no_data.includes(item.hourly_pay_amount)">${{ parseFloat(item.hourly_pay_amount).toFixed(2) }}</span>
                            <em v-else class="grey--text">No Data</em>
                          </td>
                        </tr>
                        <tr v-if="activePayrollData.includes('overtime_hours')">
                          <td style="width: 280px;">Overtime Pay</td>
                          <td>
                            <span v-if="!no_data.includes(item.overtime_pay_amount)">${{ parseFloat(item.overtime_pay_amount).toFixed(2) }}</span>
                            <em v-else class="grey--text">No Data</em>
                          </td>
                        </tr>
                        <tr>
                          <td style="width: 280px;"><strong>Performance Bonus Total</strong></td>
                          <td>
                            <span v-if="!no_data.includes(item.performance_bonuse_total)">
                              <strong>${{ item.performance_bonuse_total }}</strong>
                            </span>
                            <em v-else class="grey--text">No Data</em>
                          </td>
                        </tr>
                      </template>
                      <template v-slot:footer>
                        <v-divider></v-divider>
                        <v-container class="pa-2">
                          <v-layout class="py-2 px-2">
                            <v-flex style="max-width: 36px;">
                              <v-icon class="fill-height" color="info" size="18px">info</v-icon>  
                            </v-flex>
                            <v-flex>
                              <span class="font-italic caption fill-height">Performance Bonus = [(Pay Period Revenue +/- Revenue Adjustment) x Base Percentage] - Hourly Pay - Overtime Pay</span>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-flex>

              </v-layout>
              <v-card class="mb-12 mt-2">
                <h3 class="px-4 py-6">Payroll Summary</h3>
                <v-divider></v-divider>
                <v-data-table
                  :headers="headers3"
                  :items="items"
                  :loading="loading || payrollReportLoading"
                  loader-height="2"
                  hide-default-footer
                  class="elevation-0 sr-pl-sh-table sr-pl-sh-table-pricing"
                  colwidth-1='30px'
                  mobile-breakpoint="100"
                >
                  <template v-slot:item="{item}">
                    <tr v-if="activePayrollData.includes('mileage_rate')">
                      <td>Mileage Reimbursement</td>
                      <td>
                        <span v-if="!no_data.includes(item.private_mileage_total)">
                          {{parseFloat(item.private_mileage_total).toFixed(2)}} mi.
                        </span>
                        <em v-else class="grey--text">No data</em>
                      </td>
                      <td>
                        <span v-if="!no_data.includes(item.mileage_rate)">
                        ${{parseFloat(item.mileage_rate).toFixed(2)}} / mi.
                        </span>
                        <em v-else class="grey--text">No data</em>               
                      </td>
                      <td></td>
                      <td>
                        <span v-if="!no_data.includes(item.mileage_reimbursement_amount)">
                          ${{item.mileage_reimbursement_amount}}
                        </span>
                        <em v-else class="grey--text">No data</em> 
                      </td>
                    </tr>
                    <tr v-if="activePayrollData.includes('hourly_rate')">
                      <td>Hourly Pay</td>
                      <td>
                        <span v-if="!no_data.includes(item.regular_hours)">
                          {{parseFloat(item.regular_hours).toFixed(2)}} hr.
                        </span>
                        <em v-else class="grey--text">No data</em> 
                      </td>
                      <td>
                        <span v-if="!no_data.includes(item.hourly_rate)">
                          ${{parseFloat(item.hourly_rate).toFixed(2)}} / hr.
                        </span>
                        <em v-else class="grey--text">No data</em> 
                      </td>
                      <td></td>
                      <td>
                        <span v-if="!no_data.includes(item.hourly_pay_amount)">
                          ${{item.hourly_pay_amount}}
                        </span>
                        <em v-else class="grey--text">No data</em> 
                      </td>
                    </tr>
                    <tr v-if="activePayrollData.includes('yard_rate')">
                      <td>Per Yard Pay</td>
                      <td>
                        <span v-if="!no_data.includes(item.number_of_jobs)">
                          {{parseFloat(item.number_of_jobs).toFixed(0)}} yard
                        </span>
                        <em v-else class="grey--text">No data</em> 
                      </td>
                      <td>
                        <span v-if="!no_data.includes(item.yard_rate)">
                          ${{parseFloat(item.yard_rate).toFixed(2)}} / yard
                        </span>
                        <em v-else class="grey--text">No data</em> 
                      </td>
                      <td></td>
                      <td>
                        <span v-if="!no_data.includes(item.yard_pay_amount)">
                          ${{item.yard_pay_amount}}
                        </span>
                        <em v-else class="grey--text">No data</em> 
                      </td>
                    </tr>
                    <tr v-if="activePayrollData.includes('fixed_rate')">
                      <td>Fixed Pay</td>
                      <td>
                        <span>
                          1 pay period
                        </span>
                      </td>
                      <td>
                        <span v-if="!no_data.includes(item.fixed_rate)">
                          ${{parseFloat(item.fixed_rate).toFixed(2)}} / pay period
                        </span>
                        <em v-else class="grey--text">No data</em> 
                      </td>
                      <td></td>
                      <td>
                        <span v-if="!no_data.includes(item.fixed_pay_amount)">
                          ${{item.fixed_pay_amount}}
                        </span>
                        <em v-else class="grey--text">No data</em> 
                      </td>
                    </tr>
                    <tr v-if="activePayrollData.includes('overtime_hours')">
                      <td>Overtime Pay</td>
                      <td>
                        <span v-if="!no_data.includes(item.overtime_hours)">
                          {{parseFloat(item.overtime_hours).toFixed(2)}} hr.
                        </span>
                        <em v-else class="grey--text">No data</em> 
                      </td>
                      <td>
                        <span v-if="!no_data.includes(item.hourly_rate)">
                          1.5 x ${{parseFloat(item.hourly_rate).toFixed(2)}} / hr.
                        </span>
                        <em v-else class="grey--text">No data</em> 
                      </td>
                      <td></td>
                      <td>
                        <span v-if="!no_data.includes(item.overtime_pay_amount)">
                          ${{item.overtime_pay_amount}}
                        </span>
                        <em v-else class="grey--text">No data</em> 
                      </td>
                    </tr>
                    <tr v-if="activePayrollData.includes('holiday')">
                      <td>Holiday Pay</td>
                      <td>
                        <span v-if="!no_data.includes(item.holiday)">
                          {{parseFloat(item.holiday).toFixed(2)}} hr.
                        </span>
                        <em v-else class="grey--text">No data</em> 
                      </td>
                      <td>
                        <span v-if="!no_data.includes(item.hourly_rate)">
                          ${{parseFloat(item.hourly_rate).toFixed(2)}} / hr.
                        </span>
                        <em v-else class="grey--text">No data</em> 
                      </td>
                      <td></td>
                      <td>
                        <span v-if="!no_data.includes(item.holiday_pay_amount)">
                          ${{item.holiday_pay_amount}}
                        </span>
                        <em v-else class="grey--text">No data</em> 
                      </td>
                    </tr>
                    <tr v-if="activePayrollData.includes('vacation_hours')">
                      <td>Vacation Pay</td>
                      <td>
                        <span v-if="!no_data.includes(item.vacation_hours)">
                          {{parseFloat(item.vacation_hours).toFixed(2)}} hr.
                        </span>
                        <em v-else class="grey--text">No data</em> 
                      </td>
                      <td>
                        <span v-if="!no_data.includes(item.hourly_rate)">
                          ${{parseFloat(item.hourly_rate).toFixed(2)}} / hr.
                        </span>
                        <em v-else class="grey--text">No data</em> 
                      </td>
                      <td></td>
                      <td>
                        <span v-if="!no_data.includes(item.vacation_pay_amount)">
                          ${{item.vacation_pay_amount}}
                        </span>
                        <em v-else class="grey--text">No data</em> 
                      </td>
                    </tr>
                    <tr v-if="activePayrollData.includes('pto_hours')">
                      <td>PTO Pay</td>
                      <td>
                        <span v-if="!no_data.includes(item.pto_hours)">
                          {{parseFloat(item.pto_hours).toFixed(2)}} hr.
                        </span>
                        <em v-else class="grey--text">No data</em> 
                      </td>
                      <td>
                        <span v-if="!no_data.includes(item.hourly_rate)">
                          ${{parseFloat(item.hourly_rate).toFixed(2)}} / hr.
                        </span>
                        <em v-else class="grey--text">No data</em> 
                      </td>
                      <td></td>
                      <td>
                        <span v-if="!no_data.includes(item.pto_pay_amount)">
                          ${{item.pto_pay_amount}}
                        </span>
                        <em v-else class="grey--text">No data</em> 
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <v-divider></v-divider>
                  <div v-if="items.length === 1" class="inv-desc-table-style inv-desc-total">
                    <div class="inv-desc-amount-titles">
                      <p><strong>Subtotal</strong></p>
                      <p v-if="activePayrollData.includes('tips')">Tips</p>
                      <p v-if="items.length === 1 && parseFloat(items[0].revenue_rate) !== 0 && activePayrollData.includes('base_percentage')">Performance Bonus Total</p>
                      <p v-if="activePayrollData.includes('addl_bonus')">Additional Bonus</p>
                      <p v-if="activePayrollData.includes('reimbursement')">Msc Reimbursement</p>
                      <p v-if="activePayrollData.includes('deduction')">Deductions</p>
                      <p class="inv-total-text"><strong>Total</strong></p>
                    </div>
                    <div class="inv-desc-amount-values">
                      <p style="height: 20px;">
                        <span v-if="!no_data.includes(items[0].payroll_summary_subtotal)">
                          ${{items[0].payroll_summary_subtotal}}
                        </span>
                        <em v-else class="grey--text">No Data</em>
                      </p>
                      <p v-if="activePayrollData.includes('tips')">
                        <span v-if="!no_data.includes(items[0].tips)">
                          ${{parseFloat(items[0].tips).toFixed(2)}}
                        </span>
                        <em v-else class="grey--text">No Data</em>
                      </p>
                      <p v-if="items.length === 1 && parseFloat(items[0].revenue_rate) !== 0 && activePayrollData.includes('base_percentage')">
                        <span v-if="!no_data.includes(items[0].performance_bonuse_total)">
                          ${{items[0].performance_bonuse_total}}
                        </span>
                        <em v-else class="grey--text">No Data</em>
                      </p>
                      <p v-if="activePayrollData.includes('addl_bonus')">
                        <span v-if="!no_data.includes(items[0].bonus)">
                          ${{parseFloat(items[0].bonus).toFixed(2)}}
                        </span>
                        <em v-else class="grey--text">No Data</em>
                      </p>
                      <p v-if="activePayrollData.includes('reimbursement')">
                        <span v-if="!no_data.includes(items[0].reimbursement)">
                          ${{parseFloat(items[0].reimbursement).toFixed(2)}}
                        </span>
                        <em v-else class="grey--text">No Data</em>
                      </p>
                      <p v-if="activePayrollData.includes('deduction')">
                        <span v-if="!no_data.includes(items[0].deduction)">
                          ${{parseFloat(items[0].deduction).toFixed(2)}}
                        </span>
                        <em v-else class="grey--text">No Data</em>
                      </p>
                      <p class="inv-total-text" style="height: 20px;">
                        <strong v-if="!no_data.includes(items[0].complete_total)">
                          ${{items[0].complete_total}}
                        </strong>
                        <em v-else class="grey--text">No Data</em>
                      </p>
                    </div>
                  </div>
                </v-card>
            </v-container>


        </div>
    </v-app>
</template>

<script>
    import EventBus from '@/main'
    import ApiService from "@/common/api.service"
    import moment from "moment"
    import calculatePayroll from "@/common/calculatePayroll.js"
    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: "PayrollReportShow",
        mixins: [calculatePayroll],
        data: () => ({
            weekStartEnd: [],
            menu1: false,
            no_data: [null, '', undefined, 'null'],
            items: [],
            total_overtime: '',
            total_payroll: '',
            total_revenue: '',
            loading: false,
            loadingOrganizationSettings: false,
            payrollReportLoading: false,

            employee: null,
            headers1: [
              {
                text: 'Employee Figures',
                align: 'left',
                sortable: false,
                value: 'Summary',
                width: '200px'
              },
              {
                sortable: false,
              }
            ],
            headers2: [
              {
                text: 'Performance Bonus',
                align: 'left',
                sortable: false,
                value: 'Summary',
                width: '200px'
              },
              {
                sortable: false,
              }
            ],
            headers3: [
              {
                text: 'Pay Item',
                align: 'left',
                sortable: false,
                value: 'Description',
              },
              {
                text: 'Qty',
                sortable: false,
                value: 'Quantity',
              },
              {
                text: 'Rate',
                sortable: false,
                value: 'Rate',
                width: '20%'
              },
              {
                sortable: false,
              },
              {
                text: 'Amount',
                sortable: false,
                value: 'Amount',
                width: '200px'

              }
            ],
            payrollFilter: [
              { 'slug': 'years_in_service', 'name': 'Years in Service', 'show': true, 'defaultShow': true }, 
              { 'slug': 'worked_hours', 'name': 'Worked Hours', 'show': true, 'defaultShow': true }, 
              { 'slug': 'residential_revenue', 'name': 'Residential Revenue', 'show': true, 'defaultShow': false },
              { 'slug': 'residential_bonus', 'name': 'Additional Residential Services Revenue', 'show': true, 'defaultShow': false },
              { 'slug': 'commercial_revenue', 'name': 'Commercial Revenue', 'show': true, 'defaultShow': false },
              { 'slug': 'commercial_bonus', 'name': 'Additional Commercial Services Revenue', 'show': true, 'defaultShow': false },
              { 'slug': 'revenue', 'name': 'Revenue', 'show': true, 'defaultShow': true }, 
              { 'slug': 'revenue_adjustment', 'name': 'Revenue Adjustment', 'show': true, 'defaultShow': true }, 
              { 'slug': 'distance', 'name': 'Distance', 'show': true, 'defaultShow': true }, 
              { 'slug': 'regular_hours', 'name': 'Regular Hours', 'show': true, 'defaultShow': true }, 
              { 'slug': 'overtime_hours', 'name': 'Overtime Hours', 'show': true, 'defaultShow': true }, 
              { 'slug': 'holiday', 'name': 'Holiday Hours', 'show': true, 'defaultShow': true }, 
              { 'slug': 'vacation_hours', 'name': 'Vacation Hours', 'show': true, 'defaultShow': true }, 
              { 'slug': 'pto_hours', 'name': 'PTO', 'show': true, 'defaultShow': true }, 
              { 'slug': 'tips', 'name': 'Tips', 'show': true, 'defaultShow': true }, 
              { 'slug': 'addl_bonus', 'name': 'Addl Bonus', 'show': true, 'defaultShow': true }, 
              { 'slug': 'reimbursement', 'name': 'Msc Reimb', 'show': true, 'defaultShow': true }, 
              { 'slug': 'deduction', 'name': 'Deductions', 'show': true, 'defaultShow': true }, 
              { 'slug': 'number_of_jobs', 'name': 'Nr of Jobs', 'show': true, 'defaultShow': true }, 
              { 'slug': 'number_of_complaints', 'name': 'Nr of Complaints', 'show': true, 'defaultShow': true }, 
              { 'slug': 'mileage_rate', 'name': 'Mileage Rate', 'show': true, 'defaultShow': true }, 
              { 'slug': 'hourly_rate', 'name': 'Hourly Rate', 'show': true, 'defaultShow': true }, 
              { 'slug': 'base_percentage', 'name': 'Base Percentage', 'show': true, 'defaultShow': true }, 
              { 'slug': 'yard_rate', 'name': 'Per Yard Rate', 'show': true, 'defaultShow': true }, 
              { 'slug': 'fixed_rate', 'name': 'Fixed Rate', 'show': true, 'defaultShow': true }
            ],
        }),
        mounted() {
          this.initialize()
        },
        methods: {
            ...mapActions(['checkOrganizationSettings']),
            initialize() {
              this.loading = true
              this.getOrganizationSettings()
                .then(() => {
                  return this.getPayrollReport()
                })
                .then(() => {
                  this.loading = false
                })
                .catch(error => {
                  this.loading = false
                })
            },
            getPayrollReport() {
                this.payrollReportLoading = true;
                return new Promise((resolve, reject) => {
                let body = {
                  staff_id: this.$route.params.id,
                  date_from: this.weekStartEnd[0], 
                  date_to: this.weekStartEnd[this.weekStartEnd.length - 1]
                }

                ApiService.get('/payroll/employee_report', body)
                        .then(response => {
                            this.employee = response.data.employee
                            let items = response.data.revenue
                            this.items = [this.calculatePayroll(items)]
                            this.payrollReportLoading = false
                            resolve()
                        })
                        .catch(error => {
                          console.log(error);
                          this.payrollReportLoading = false
                          reject()
                        })
                })
            },
            getOrganizationSettings() {
              this.loadingOrganizationSettings = true;
              return new Promise((resolve, reject) => {
              this.checkOrganizationSettings()
                .then(response => {
                  if(response.payroll_filter) {
                    let filter_value = response.payroll_filter.split(',')
                    this.payrollFilter.forEach(i => { i.show = filter_value.includes(i.slug)})
                  }
                  this.setWeekStartEnd(this.$route.params.date_from)
                  this.loadingOrganizationSettings = false;
                  resolve()
                })
                .catch(error => {
                  console.log(error);
                  this.loadingOrganizationSettings = false;
                  reject()
                });
              })
            },
            getIndex(array, key, value) {
                return array.findIndex(i => i[key] == value)
            },
            updateWeek (newDate) {
              const oldDate = this.weekStartEnd
              if (newDate.length < oldDate.length) {
                this.weekStartEnd = oldDate
                return
              }

              const selectedDate = newDate[newDate.length - 1]
              this.setWeekStartEnd(selectedDate)
              this.menu1 = false
            },
            setWeekStartEnd(selectedDate) {
              this.weekStartEnd = this.payPeriodDays(selectedDate);
            },
            titleDateFormat () {
              if(this.weekStartEnd.length) {
                return `${this.weekStartEnd[0]} - ${this.weekStartEnd[this.weekStartEnd.length - 1]}`
              } else {
                return ''
              }
            },
            weekDateFormat () {
              if(this.weekStartEnd.length) {
                if(this.payPeriod === 'weekly') {
                  return `Week ${moment(this.weekStartEnd[0]).week()}`
                }
                return `${moment(this.weekStartEnd[0]).format('MM[-]DD')} to ${moment(this.weekStartEnd[this.weekStartEnd.length - 1]).format('MM[-]DD')}`
              } else {
                return ''
              }
            },
            onlyDate(d = '') {
              return moment(d).format('YYYY[-]MM[-]DD')
            }
        },
        computed: {
          ...mapGetters([
            'organizationSettings',
            'payPeriodDays',
            'payPeriod',
            'payPeriodName',
          ]),
          activePayrollData() {
            return this.payrollFilter.filter(i => i.show).map(i => i.slug)
          }
        }
    }
</script>
<style>

    /**tools table**/
    .payroll-report-show-wrap div.datatable.table {
        margin-bottom: 0%;
    }

    .payroll-report-show-wrap .header-search-single {
        padding-bottom: 0px;
    }

    /*Search field width*/
    .search-org {
        min-width: 120px;
    }

    td a {
        text-decoration: none;
    }

    .dialog-heading {
        background-color: #efefef;
        padding: 10px;
    }

    .no-opacity {
        opacity: 0;
    }

    .clear-filters {
        text-transform: none;
        color: #00838F;
        cursor: pointer;
        text-decoration: underline;
        font-size: 14px;
    }

    .payroll-report-show-wrap .table-head-text {
      white-space: normal; 
      text-align: left;
      min-width: 100px;
    }

    .table-org td.actions-position {
      position: absolute;
      right: 0;
      border-left: 1px solid rgba(0,0,0,0.12)!important;
      border-top: none!important;
      border-bottom: none!important;
      padding-top: 13px!important;
      padding-bottom: 13px!important;
      background: #fff;

      -webkit-transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      will-change: background;
    }

    .table-org th.actions-position::before {
      content: "Actions";
      position: absolute;
      top: 0;
      right: 0;
      padding: 19px 24px;
      border-left: 1px solid rgba(0,0,0,0.12)!important;
      border-top: none!important;
      border-bottom: none!important;
      text-align: left;
      width: 109px;
      height: 56px;
      background: #fff;
    }

    .table-org th.actions-position {
        width: 108px!important;
    }

    .table-org tr:not(:nth-child(1)) td.actions-position {
      border-bottom: 1px solid rgba(0,0,0,0.12)!important;  
    }

    .table-org tr:hover td.actions-position {
      background: #e0f5f8;
    }

    .vertical-table-devider {
      border-left: 1px solid #00838F;
    }

    /*Invoice total section*/
    .inv-desc-total {
      text-align: right;
      font-size: 14px;
    }

    .inv-desc-amount-titles {
      display: inline-block;
      padding-right: 50px;
      font-size: 14px;
    }

    .inv-desc-amount-values {
      display: inline-block;
      text-align: left;
      width: 208px;
      padding: 24px;
    }

    .inv-edit-table-desc>.v-table__overflow {
      overflow-x: hidden !important;
      overflow-y: hidden !important;
      }

    .wrap-inv-description{
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden
    }
    .memo {
      padding: 15px 24px;
      font-size: 13px;
    }

    .payroll-report-show-wrap .custom-column-width {
      min-width: 180px!important;
      max-width: 180px!important;
    }
</style>
